module.exports = __webpack_public_path__ + "static/media/fly0056.47ca7be9.webp";